module.exports = __webpack_public_path__ + "static/media/Hays_CISD_Logo.0a707884.png";